/*! jQuery Fancy File Input plugin - v3.0.0 - 2026-02-11
 * Copyright (c) 2026 Atlassian Pty Ltd
 * Author: Atlassian Pty Ltd
 * License: Apache-2.0 */

(function webpackUniversalModuleDefinition(root, factory) {

      if(typeof exports === 'object' && typeof module === 'object') {
          module.exports = factory(require("jquery"));
      }else if(typeof define === 'function' && define.amd) {
          
          define("FancyFileInput", ["jquery"], factory);

          } else if(typeof exports === 'object'){

          
      exports["FancyFileInput"] = factory(require("jquery"));

      } else {

          
      root["FancyFileInput"] = factory(root["jQuery"]);
      }

      })(this, (__rspack_external__930) => {
          return (() => {
var __webpack_modules__ = ({
930(module) {
"use strict";
module.exports = __rspack_external__930;

},

});
// The module cache
var __webpack_module_cache__ = {};

// The require function
function __webpack_require__(moduleId) {

// Check if module is in cache
var cachedModule = __webpack_module_cache__[moduleId];
if (cachedModule !== undefined) {
return cachedModule.exports;
}
// Create a new module (and put it into the cache)
var module = (__webpack_module_cache__[moduleId] = {
exports: {}
});
// Execute the module function
__webpack_modules__[moduleId](module, module.exports, __webpack_require__);

// Return the exports of the module
return module.exports;

}

var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
(() => {
/**
 * --------------------------------------------------------------------
 * jQuery Fancy File Input plugin
 * Author: Atlassian Pty Ltd
 * Copyright © 2012 - 2016 Atlassian Pty Ltd. Licensed under the
 * Apache License, Version 2.0 (the "License"); you may not use this
 * file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
 * implied. See the License for the specific language governing
 * permissions and limitations under the License.
 * --------------------------------------------------------------------
 */
const $ = __webpack_require__(930);

const fakePathRegex = /^.*[\\\/]/;
const multipleFileTextRegex = /\{0\}/gi;

function FancyFileInput(el, options) {
    const instance = $(el).data('FancyFileInput');
    if (instance) {
        return instance;
    }
    options = $.extend({}, FancyFileInput.defaults, options);
    this.el = el;
    this.$el = $(el);
    this.$label = this.createLabel(options.buttonText);
    this._addLabelText();
    this.$clearButton = $('<button>', {
        text: (this.$label.attr('data-ffi-clearButtonText') || options.clearButtonText),
        'class': 'ffi-clear',
        type: 'button',
        'tabindex': '-1',
    });
    this.multipleFileTextPattern = this.$label.attr('data-ffi-multipleFileTextPattern') || options.multipleFileTextPattern;
    this._eventNamespace = '.ffi';
    this.CLASSES = {
        disabled: 'is-disabled',
        focused: 'is-focused',
        active: 'is-active',
        valid: 'is-valid',
        invalid: 'is-invalid',
    };
    this[this.isDisabled() ? 'disable' : 'enable']();
}

FancyFileInput.defaults = {
    buttonText: 'Browse\u2026',
    clearButtonText: 'Clear',
    multipleFileTextPattern: '{0} files',
};

FancyFileInput.prototype._addLabelText = function attLabelText() {
    const $associatedLabel = $('label[for="' + this.el.id + '"]');
    if ($associatedLabel.length) {
        this.$el.attr('aria-label', $associatedLabel.text());
    }
};

FancyFileInput.prototype.createLabel = function (buttonText) {
    let $label = this.$el.parent('.ffi[data-ffi-button-text]');
    if (!$label.length) {
        $label = this.$el.wrap($('<label>', { 'class': 'ffi', 'data-ffi-button-text': buttonText })).parent();
    }
    return $label;
};

FancyFileInput.prototype.isDisabled = function () {
    return this.$el.is(':disabled');
};

FancyFileInput.prototype.formatMultipleFileText = function (numFiles) {
    return this.multipleFileTextPattern.replace(multipleFileTextRegex, numFiles);
};

FancyFileInput.prototype.bindEvents = function () {
    this.$el
        .on('invalid'   + this._eventNamespace, this.checkValidity.bind(this))
        .on('change'    + this._eventNamespace, this.change.bind(this))
        .on('keydown'   + this._eventNamespace, this.keydown.bind(this))
        .on('mousedown' + this._eventNamespace, this.mousedown.bind(this))
        .on('mouseup'   + this._eventNamespace, this.mouseup.bind(this))
        .on('focus'     + this._eventNamespace, this.focus.bind(this))
        .on('blur'      + this._eventNamespace, this.blur.bind(this));
    this.$clearButton.on('click' + this._eventNamespace, this.clear.bind(this));
};

FancyFileInput.prototype.unbindEvents = function () {
    this.$el.off(this._eventNamespace);
    this.$clearButton.off(this._eventNamespace);
};

FancyFileInput.prototype.fireEvent = function (event) {
    this.$el.trigger(event + this._eventNamespace);
};

FancyFileInput.prototype.enable = function () {
    this.bindEvents();
    this.$el.prop('disabled', false);
    this.$label.removeClass(this.CLASSES.disabled);
};

FancyFileInput.prototype.disable = function () {
    this.unbindEvents();
    this.$el.prop('disabled', true);
    this.$label.addClass(this.CLASSES.disabled);
};

FancyFileInput.prototype.clear = function () {
    this.$el.wrap('<form>').closest('form').get(0).reset();
    this.$el.unwrap();
    this.el.value = '';
    this.change();
    return false;
};

FancyFileInput.prototype.focus = function () {
    this.$label.addClass(this.CLASSES.focused);
};

FancyFileInput.prototype.blur = function () {
    this.$label.removeClass(this.CLASSES.focused);
};

FancyFileInput.prototype.mousedown = function () {
    this.$label.addClass(this.CLASSES.active);
};

FancyFileInput.prototype.mouseup = function () {
    this.$label.removeClass(this.CLASSES.active);
};

FancyFileInput.prototype.keydown = function (e) {
    const keyCode = e.which;
    const BACKSPACE = 8;
    const DELETE = 46;

    if (keyCode === BACKSPACE || keyCode === DELETE) {
        this.clear();
        e.preventDefault();
    }
};

FancyFileInput.prototype.checkValidity = function () {
    if (!this.el.required) {
        return;
    }
    const isInvalid = this.$el.is(':invalid');

    this.$label.toggleClass(this.CLASSES.invalid, isInvalid).toggleClass(this.CLASSES.valid, !isInvalid);
};

FancyFileInput.prototype.change = function () {
    let files;
    let val = '';

    this.checkValidity();

    // multiple file selection
    if (this.el.multiple && this.el.files.length > 1) {
        files = this.formatMultipleFileText(this.el.files.length); // '5 files'
    } else {
        files = this.el.value; // 'README.txt'
    }

    if (files.length) {
        val = files.replace(fakePathRegex, ''); // Strips off the C:\fakepath nonsense
        this.$clearButton.appendTo(this.$label);
    } else {
        this.$clearButton.detach();
    }

    this.$el.focus();
    this.setFieldText(val);
    this.fireEvent('value-changed');
};

FancyFileInput.prototype.setFieldText = function (text) {
    const dataAttribute = 'data-ffi-value';
    if (text.length) {
        this.$label.attr(dataAttribute, text);
        this.fireEvent('value-added');
    } else {
        this.$label.removeAttr(dataAttribute);
        this.fireEvent('value-cleared');
    }
};

$.fn.fancyFileInput = function (options) {
    return this.each(function () {
        const ffi = new FancyFileInput(this, options);
        $(this).data('FancyFileInput', ffi);
    });
};

})();

return __webpack_exports__;
})()

});